import { noop } from "../../../common/function";
import { PREFIX } from "../index.js";
import { dispatchTrackingEvent, synteticEvents } from "../event/event";
import { loggerScope } from "../parser/utils";
import type { Unset } from "../../event/index.js";

const EVENT_NAME = synteticEvents[1];
const log = loggerScope.scope(EVENT_NAME);

/**
 *
 *
 *
 */
const register = (elementToTrack: HTMLElement): Unset => {
  log.info("dispatch page impression", elementToTrack);

  if (!dispatchTrackingEvent(elementToTrack, EVENT_NAME, { [PREFIX]: { method: "submitMerge" } }))
    log.debug(EVENT_NAME, "has been terminated by lifecycle hook for", elementToTrack);

  return noop;
};

const synteticPageImpression = [EVENT_NAME, register] as const;
export default synteticPageImpression;
